<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow, }"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/QIAOHU/PC/X.png">
                </div>

                <div class="modal-body">
                    <img :src="qiaohuImage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QiaohuPopup",
    props: {
        isShow: {
            type: Boolean
        },
        shipCode: {
            type: String
        },
        sailDate: {
            type: String
        },
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    computed: {
        qiaohuImage () {
            if ((this.shipCode == "QN" && this.sailDate == "2020-09-06") || (this.shipCode == "SC" && this.sailDate == "2020-11-08")) {
                return 'https://resource.rcclchina.com.cn/QIAOHU/PC/QIAOHU5-20200102.png'
            } else {
                // return 'https://resource.rcclchina.com.cn/QIAOHU/PC/QIAOHU3-20200102.png'
              return 'https://resource.rcclchina.com.cn/QIAOHU/PC/QIAOHU-PC-popup_v1.2.png'
            }
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal {
    overflow-y: auto;
    .modal-content {
        padding: 0px;
        background: transparent;
        box-shadow: none;
        border: none;
    }
}
.modal-body {
    padding: 0px;
    img {
        width: 100%;
    }
}
.modal-dialog {
    top: 15%;
    width: 1028px !important;
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
